import classNames from 'classnames';
import React from 'react';
import { TextOverflow } from '../../../helpers/enums/textOverflow.js';
export { TextOverflow } from '../../../helpers/enums/textOverflow.js';
import styles from './Heading.scss.js';

const Heading = _ref => {
  let {
    type: HeadingComponent,
    textOverflow,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(HeadingComponent, {
    className: classNames(styles.heading, styles['np-base'], {
      [styles['heading--overflow-elipsis']]: textOverflow === TextOverflow.Ellipsis
    })
  }, children);
};

export { Heading };
//# sourceMappingURL=Heading.js.map
